import router from './router';
const name = '插件脚手架';

export {
  name,
  router,
}
